export default class KlaroController {
    constructor(selector) {
        this.selector = selector;
        this.klaro = document.getElementById('klaro');
        this.triggerEl = null;

        this.keyboardHandler = this.keyboardHandler.bind(this);

        this.init();
    }

    init() {
        document.addEventListener('click', (event) => {
            const trigger = event.target.closest(this.selector);

            if (!trigger) {
                return;
            }

            event.preventDefault();
            this.open(trigger);
        });
    }

    open(trigger) {
        this.triggerEl = trigger;

        if (typeof window.klaroConfig !== 'undefined') {
            window.klaroConfig.consents = [];
            window.klaroConfig.mustConsent = true;
        }

        if (
            typeof window.klaro !== 'undefined' &&
            typeof window.klaro.show === 'function'
        ) {
            window.klaro.show();
        } else if (this.klaro) {
            this.klaro.classList.add('klaro--visible');
            this.klaro.setAttribute('aria-hidden', 'false');
        }

        this.waitForKlaro();
    }

    waitForKlaro() {
        const klaro = document.getElementById('klaro');

        if (!klaro) {
            return;
        }

        const focusables = klaro.querySelectorAll(
            'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        const isVisible = klaro.offsetParent !== null;

        if (isVisible && focusables.length > 0) {
            focusables[0].focus();

            window.removeEventListener('keydown', this.keyboardHandler);
            window.addEventListener('keydown', this.keyboardHandler);

            return;
        }

        requestAnimationFrame(() => this.waitForKlaro());
    }

    close() {
        if (
            typeof window.klaro !== 'undefined' &&
            typeof window.klaro.saveAndApplyConsents === 'function'
        ) {
            window.klaro.saveAndApplyConsents();
        } else if (this.klaro) {
            this.klaro.classList.remove('klaro--visible');
            this.klaro.setAttribute('aria-hidden', 'true');
        }

        window.removeEventListener('keydown', this.keyboardHandler);

        if (this.triggerEl) {
            this.triggerEl.focus();
        }
    }

    keyboardHandler(event) {
        const container = document.getElementById('klaro');

        if (!container || container.offsetParent === null) {
            return;
        }

        const focusableElements = container.querySelectorAll(
            'button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );

        if (focusableElements.length === 0) {
            return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (
                event.shiftKey &&
                document.activeElement === firstElement
            ) {
                event.preventDefault();
                lastElement.focus();
            } else if (
                !event.shiftKey &&
                document.activeElement === lastElement
            ) {
                event.preventDefault();
                firstElement.focus();
            }
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
        }
    }
}